var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3814 33.7887V28.4484C49.3814 26.6804 47.9742 25.2732 46.2062 25.2732H15.1753C13.4072 25.2732 12 26.6804 12 28.4484V33.7887V69.4021C12 71.1701 13.4072 72.5773 15.1753 72.5773H64.8247C66.5928 72.5773 68 71.1701 68 69.4021V36.9639C68 35.1959 66.5928 33.7887 64.8247 33.7887H49.3814Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2419 41.2576L39.9997 47.4998L33.7213 41.2576L29.9688 45.0101L36.211 51.2885L29.9688 57.5308L33.7213 61.3194L39.9997 55.0411L46.2419 61.3194L49.9945 57.5308L43.7523 51.2885L49.9945 45.0101L46.2419 41.2576Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6088 74.8299C70.5549 73.9031 70.5549 72.397 69.6474 71.4703L58.6996 60.3293L55.3013 63.6697L66.2491 74.8106C67.1566 75.7374 68.6627 75.7567 69.6088 74.8299Z",
    fill: "#1F44DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.085 64.5962C44.7745 64.5842 40.4792 60.2694 40.4913 54.9589C40.5033 49.6484 44.8181 45.3531 50.1286 45.3652C55.4391 45.3772 59.7344 49.692 59.7223 55.0025C59.7103 60.313 55.3955 64.6083 50.085 64.5962Z",
    fill: "#DCF0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3259 47.0648C46.6896 42.7784 53.7178 42.8363 58.0236 47.2C62.31 51.5636 62.2521 58.5919 57.8884 62.8976C53.5247 67.1841 46.4965 67.1262 42.1908 62.7625C37.885 58.3988 37.9429 51.3706 42.3259 47.0648ZM56.4982 61.5074C60.0896 57.974 60.1475 52.1815 56.6141 48.5902C53.0806 44.9988 47.2881 44.9409 43.6968 48.4743C40.1055 52.0077 40.0475 57.8002 43.5809 61.3916C47.1144 64.9829 52.9069 65.0409 56.4982 61.5074Z",
    fill: "#1F44DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.929 64.6936L66.5791 73.4982",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2966 44.6897C52.0191 44.4194 54.8574 45.3462 56.8655 47.2191C58.8929 49.0727 60.0514 51.8145 60.0127 54.5563",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.962b797494ceb8bfacb014feb0279bca.svg";
export { ForwardRef as ReactComponent };